var angular = require("angular");
var translations = {
	"app": "Tinaba",
	"common.balance": "Saldo",
	"common.availability": "Disponibilità",
	"common.description": "Descrizione",
	"common.price": "Prezzo",
	"common.product.code": "Codice Prodotto",
	"common.name": "Nome",
	"common.amount": "Importo",
	"common.fee": "Commissione*",
	"common.details": "Dettaglio",
	"common.pdf": "PDF",
	"common.find": "Trovati",
	"common.results": "Risultati",
	"common.result": "Risultato",
	"common.image.principle": "Immagine principale",
	"common.landscapeMessage": "Per un'esperienza migliore ruota il tuo dispositivo in modalità orizzontale",
	"common.date.tagfrom": "Da",
	"common.date.tagto": "A",
	"common.date.id": "Id transazione",
	"common.date.title": "Data",
	"common.date.time": "Ora",
	"common.date.from": "Dal",
	"common.date.to": "Al",
	"common.date.today": "Oggi",
	"common.date.yesterday": "Ieri",
	"common.date.days": "Giorni",
	"common.date.day": "Giorno",
	"common.date.weeks": "Settimane",
	"common.date.week": "Settimana",
	"common.date.months": "Mesi",
	"common.date.month": "Mese",
	"common.date.current_month": "Mese corrente",
	"common.date.90days": "Ultimi 90 giorni",
	"common.date.6months": "Ultimi 6 mesi",
	"common.date.custom": "Personalizzato",
	"common.date.years": "Anno",
	"common.date.monday": "Lunedì",
	"common.date.tuesday": "Martedì",
	"common.date.wednesday": "Mercoledì",
	"common.date.thursday": "Giovedì",
	"common.date.friday": "Venerdì",
	"common.date.saturday": "Sabato",
	"common.date.sunday": "Domenica",
	"common.state.title": "Stato",
	"common.state.active": "Attivo",
	"common.state.inactive": "Inattivo",
	"common.code": "Codice",
	"common.instruments.bank": "Conto",
	"common.instruments.wallet": "Wallet",
	"common.instruments.card": "Carta",
	"common.instruments.bankAccount": "Conto Corrente",
	"common.instruments.prepaidCard": "Carta Prepagata",
	"common.instruments.unavailableCard": "Carta non disponibile",
	"common.loading": "Caricamento...",
	"common.privacy": "Privacy",
	"common.average": "Media",
	"common.total": "Totale",
	"common.email": "Indirizzo email punto vendita",
	"common.email.legal": "Indirizzo mail del legale rappresentante",
	"common.mobile_1": "Numero di telefono",
	"common.mobile_2": "del legale rappresentante",
	"common.phone": "Telefono",
	"common.web": "Web",
	"common.customName": "Testo Custom",
	"common.customValue": "Link Custom",
	"common.facebook": "Facebook",
	"common.twitter": "Twitter",
	"common.instagram": "Instagram",
	"common.youtube": "Youtube",
	"common.tiktok": "Tik Tok",
	"common.shopName": "INSEGNA DEL TUO PUNTO VENDITA",
	"common.shopNameAlias": "(che sarà visibile agli utenti Tinaba)",
	"common.businessName": "Ragione Sociale",
	"common.alias": "Denominazione",
	"common.vat": "Partita IVA",
	"common.registeredOffice": "Sede Legale",
	"common.sdi": "Codice univoco sdi",
	"common.pec": "Indirizzo pec",
	"common.corporateEmail": "Indirizzo email aziendale (verrà utilizzata per tutte le comunicazioni inerenti alla tua attività)",
	"common.error": "Errore",
	"common.info": "Informazione",
	"common.any": "Tutti",
	"common.empty": "Nessun risultato trovato",
	"common.configuration": "Configurazione",
	"common.export.excel": "Esporta in Excel",
	"common.address.street": "Via",
	"common.address.province": "Provincia",
	"common.address.city": "Città",
	"common.address.nr": "Civico",
	"common.address.zip": "CAP",
	"common.address.edit": "Modifica Indirizzo",
	"common.address.lat": "Latitudine",
	"common.address.lon": "Longitudine",
	"common.levels.business.A": "Level A - Biz",
	"common.levels.business.B": "Level B - Biz",
	"common.levels.business.B_TEMP": "Level B TEMP - Biz",
	"common.levels.business.C": "Level C - Biz",
	"common.levels.consumer.A": "Level A - Consumer",
	"common.levels.consumer.B": "Level B - Consumer",
	"common.levels.consumer.C": "Level C - Consumer",
	"common.levels.corporate.C": "Level C - Corporate",
	"common.levels.corporate.B": "Level B - Corporate",
	"common.levels.corporate.A": "Level A - Corporate",
	"common.levels.consumer.0": "Level C - Consumer",
	"common.levels.consumer.1": "Level B - Consumer",
	"common.levels.consumer.2": "Level A - Consumer",
	"common.levels.merchant.biz.0": "Level C - Biz",
	"common.levels.merchant.biz.1": "Level B - Biz",
	"common.levels.merchant.biz.2": "Level A - Biz",
	"common.levels.merchant.corporate.0": "Level C - Corporate",
	"common.levels.merchant.corporate.1": "Level B - Corporate",
	"common.levels.merchant.corporate.2": "Level A - Corporate",
	"common.filters.title": "Filtra",
	"common.filters.reset": "Azzera filtri",
	"common.filters.results": "Risultato ricerca",
	"common.buttons.load.img": "Carica immagine",
	"common.buttons.load": "Carica",
	"common.buttons.registerPaypal": "Attiva il servizio",
	"common.buttons.save": "Salva",
	"common.buttons.ok": "Ok",
	"common.buttons.close": "Chiudi",
	"common.buttons.cancel": "Annulla",
	"common.buttons.delete": "Elimina",
	"common.buttons.activate": "Attiva",
	"common.buttons.tbd": "TBD",
	"common.buttons.send": "Invia richiesta",
	"common.buttons.zip": "Scarica .Zip",
	"common.buttons.accept": "Accetta",
	"common.buttons.create": "Aggiungi",
	"common.buttons.back": "Indietro",
	"common.buttons.next": "Avanti",
	"common.buttons.select": "Seleziona",
	"common.buttons.join": "Associa",
	"common.buttons.remove": "Rimuovi",
	"common.buttons.confirm": "Conferma",
	"common.buttons.si": "Si",
	"common.buttons.no": "No",
	"common.errors.generic": "Si è verificato un errore",
	"common.infos.success": "Operazione completata con successo",
	"merchantTermsModal.title": "Accettazione clausole convenzionamento azienda",
	"merchantTermsModal.subtitle": "Prima di proseguire è necessario prendere visione del documento ed accettare le seguenti clausole",
	"merchantTermsModal.errorNoOpenDoc": "Per accettare la clausola è necessario scaricare il documento 'Condizioni generali di contratto convenzionamento Merchant'",
	"merchantTermsModal.button": "Continua",
	"merchantTermsModal.contract": "Contratto di convenzionamento",
	"login.title": "Login",
	"login.number": "Numero di telefono",
	"login.codice": "Codice di accesso",
	"login.username": "Username",
	"login.password": "Password",
	"login.buttons.login": "Accedi",
	"login.buttons.logout": "Esci",
	"login.logout": "Esci",
	"sca.description.movements": "Per visualizzare lo storico dei movimenti oltre 90 giorni devi confermare la notifica ricevuta sul tuo device principale",
	"sca.description.documents": "Per visualizzare la documentazione conferma la notifica ricevuta sul tuo device principale",
	"sca.description.login": "PER VISUALIZZARE IL SALDO E GLI ULTIMI MOVIMENTI DEVI CONFERMARE LA NOTIFICA RICEVUTA SUL TUO DEVICE PRINCIPALE",
	"sca.notification": "Ti abbiamo inviato una notifica",
	"sca.notification.question": "Non hai ricevuto la notifica?",
	"sca.notification.resend": "Clicca per reinviarla",
	"login.errors.form.username.required": "Il numero di telefono è richiesto",
	"login.errors.form.username.minlength": "Il numero di telefono troppo corto",
	"login.errors.form.username.pattern": "il numero di telefono non è valido",
	"login.errors.form.password.required": "La password è richiesta",
	"login.errors.form.password.pattern": "La password è composta da 5 cifre",
	"login.errors.session.title": "Sessione scaduta",
	"login.errors.session.body": "Rieseguire l'accesso",
	"login.errors.credentials": "Credenziali errate",
	"login.errors.merchant": "L’accesso all’area è riservato ai profili Tinaba Level A - Biz e Level A - Corporate.",
	"login.errors.link": "Se hai un profilo Tinaba Level B-Biz e desideri fare Level Up fai click qui",
	"login.errors.locked.temporary": "Account temporaneamente bloccato. Riprova più tardi.",
	"login.errors.locked.permanent": "Account bloccato",
	"login.errors.disabled": "Account disabilitato",
	"login.errors.registration": "Registrazione da completare. Riprova ad eseguire l'accesso entro 24 ore.",
	"login.errors.pin": "Il tuo PIN è bloccato",
	"dashboard.title": "Dashboard",
	"dashboard.history": "Andamento Saldo",
	"dashboard.movements.title": "Lista movimenti",
	"dashboard.movements.recent": "Ultimi movimenti",
	"dashboard.movements.all": "Tutti i movimenti",
	"dashboard.movements.search": "Cerca tra i movimenti...",
	"dashboard.movements.empty": "Nessun movimento trovato",
	"dashboard.movements.store": "Punto vendita",
	"dashboard.movements.method": "Metodo di incasso",
	"dashboard.movements.operator.name": "Nome cassa",
	"dashboard.movements.operator.id": "Identificativo",
	"dashboard.movements.operator.id2": "univoco",
	"dashboard.movements.descriptions.merchant.in.contact": "Pagamento ricevuto da {{name}}",
	"dashboard.movements.descriptions.merchant.in.default": "Pagamento ricevuto",
	"dashboard.movements.descriptions.merchant.out.contact": "Rimborso effettuato a {{name}}",
	"dashboard.movements.descriptions.merchant.out.default": "Rimborso effettuato",
	"dashboard.movements.descriptions.consumer.p2p.in.contact": "Trasferimento ricevuto da {{name}}",
	"dashboard.movements.descriptions.consumer.p2p.in.default": "Trasferimento ricevuto",
	"dashboard.movements.descriptions.consumer.p2p.out.contact": "Trasferimento effettuato a {{name}}",
	"dashboard.movements.descriptions.consumer.p2p.out.default": "Trasferimento effettuato",
	"dashboard.movements.descriptions.consumer.p2b.in.contact": "Rimborso ricevuto da {{name}}",
	"dashboard.movements.descriptions.consumer.p2b.in.default": "Rimborso ricevuto",
	"dashboard.movements.descriptions.consumer.p2b.out.contact": "Pagamento effettuato a {{name}}",
	"dashboard.movements.descriptions.consumer.p2b.out.default": "Pagamento effettuato",
	"dashboard.movements.descriptions.consumer.recharge.account": "Ricarica da conto",
	"dashboard.movements.descriptions.merchant.in.generic": "{{title}} da {{name}} ",
	"dashboard.movements.descriptions.merchant.out.generic": "{{title}} a {{name}} ",
	"dashboard.movements.descriptions.merchant.in.generic.corporate": "{{title}} - {{name}} ",
	"dashboard.movements.descriptions.merchant.out.generic.corporate": "{{title}} - {{name}} ",
	"dashboard.movements.filter.title": "Filtra movimenti",
	"dashboard.movements.filter.options.time": "Periodo",
	"dashboard.movements.filter.options.type.title": "Tipo",
	"dashboard.movements.filter.options.type.out": "Uscite",
	"dashboard.movements.filter.options.type.in": "Entrate",
	"dashboard.movements.filter.options.type.any": "Tutti",
	"dashboard.movements.filter.options.operator": "Cassa",
	"dashboard.movements.filter.options.store": "Punto vendita",
	"dashboard.movements.filter.options.method": "Metodi di incasso",
	"dashboard.movements.filter.options.refund": "Nascondi transazioni rimborsate",
	"dashboard.pos.title": "Web POS Report",
	"dashboard.pos.history": "Andamento incassi",
	"profile.button.qrcode": "Scarica qrcode",
	"profile.title": "Profilo",
	"profile.registry.title": "Anagrafica",
	"profile.registry.management.title": "Gestione Profilo",
	"profile.registry.visibility.title": "Visibilità e contatti commerciali",
	"profile.registry.visibility.notice": "Attenzione, per inserire i contatti commerciali della tua attività devi prima attivare la VISIBILITA' PROFILO. Accedi all'App TINABA per smartphone nella sezione VISIBILITA' PROFILO ed inserisci i dati del tuo negozio.",
	"profile.registry.visibility.list.show": "Visibilità della lista",
	"profile.registry.visibility.list.description": "Rendi visibile l'indirizzo della tua attività per farti trovare nella lista degli esercenti convenzionati.",
	"profile.registry.contacts.placeholders.phone": "+39 3...",
	"profile.registry.contacts.placeholders.email": "email@...",
	"profile.registry.contacts.placeholders.web": "www.",
	"profile.registry.contacts.placeholders.facebook": "www.",
	"profile.registry.contacts.placeholders.twitter": "#",
	"profile.registry.contacts.placeholders.welcome": "scrivi una nota... (max 85 caratteri)",
	"profile.registry.contacts.placeholders.times": "Scrivi ad esempio: Aperto tutti i giorni dal Lunedì al Venerdì dalle ore 9:00 alle ore 19:00 (max 85 caratteri)",
	"profile.registry.contacts.title": "Contatti Commerciali",
	"profile.registry.contacts.description": "Indica i contatti del tuo punto vendita che verranno mostrati a tutti gli utenti sulla tua vetrina digitale Tinaba. Potrai inserire alcune o tutte informazioni richieste a tua discrezione",
	"profile.registry.contacts.notice": "Attenzione, non hai impostato il tuo punto vendita, accedi all'App TINABA per smartphone nella sezione ANAGRAFICA ed inserisci i dati.",
	"profile.registry.contacts.cover.title": "Logo punto vendita",
	"profile.registry.contacts.profile.title": "Immagine di profilo",
	"profile.registry.contacts.hero.title": "Immagine di copertina",
	"profile.registry.contacts.inside.title": "Immagine di interni",
	"profile.registry.contacts.outside.title": "Immagine di esterni",
	"profile.registry.contacts.cover.description": "Qui potrai caricare lo sfondo della tua vetrina. Ricordati di completare anche la sezione «Gestione profilo» che trovi qui sotto, inserendo l’immagine profilo della tua attività",
	"profile.registry.contacts.welcome": "Welcome message",
	"profile.registry.contacts.times": "Orari di apertura",
	"profile.registry.avatar.desc_1": "Inserisci qui o modifica l’immagine di profilo. ",
	"profile.registry.avatar.desc_2": "Questa è l’immagine che viene mostrata nella lista",
	"profile.registry.avatar.desc_3": "merchant Tinaba e in tutte le comunicazione verso",
	"profile.registry.avatar.desc_4": " i tuoi clienti",
	"profile.registry.profile.contactInfo": "I recapiti presenti in questa sezione non saranno visibili agli utenti Tinaba. Tienili sempre sotto controllo perchè sono i canali utilizzati per tutte le comunicazioni inviate da Tinaba e Banca Profilo.",
	"profile.security.title": "Sicurezza",
	"profile.security.placeholder": "Accedi all’App TINABA nella sezione SICUREZZA per modificare il tuo codice di accesso",
	"profile.security.passwordChange.title": "Modifica Codice di Accesso",
	"profile.security.passwordChange.old": "Digita il vecchio codice",
	"profile.security.passwordChange.new": "Digita il nuovo codice",
	"profile.security.passwordChange.repeat": "Ripeti il nuovo codice",
	"profile.security.passwordChange.error.format": "Il formato del codice non è corretto!",
	"profile.security.passwordChange.error.different": "I codici inseriti non coincidono",
	"profile.security.pinChange.title": "Modifica PIN",
	"profile.security.pinChange.old": "Digita il vecchio PIN",
	"profile.security.pinChange.new": "Digita il nuovo PIN",
	"profile.security.pinChange.repeat": "Ripeti il nuovo PIN",
	"profile.security.cardLock.title": "Blocco Carta",
	"profile.security.cardLock.description.title": "Vuoi bloccare la tua carta?",
	"profile.security.cardLock.description.body": "Usa questi contatti",
	"profile.security.closeAccount.title": "Chiusura Conto Corrente",
	"profile.security.closeAccount.mail": "Posta ordinaria o lettera raccomandata con ricevuta di ritorno alla sede legale della banca, indirizzo Via Cerva 28 - 20122 Milano",
	"profile.security.closeAccount.email": "Posta elettronica all'indirizzo canali_digitali@bancaprofilo.it o posta elettronica certificata (PEC) all'indirizzo canalidigitali_bprofilo@legalmail.it",
	"profile.security.closeAccount.description.title": "Vuoi chiudere il tuo conto?",
	"profile.security.closeAccount.description.body": "Per chiedere la chiusura del Conto Corrente comunica alla banca di voler rescindere il contratto tramite:",
	"profile.security.closeAccount.description.card": "Nel caso fossi in possesso di una carta prepagata ricordati di allegare foto della carta prepagata tagliata. Per evitare disagi ricorda di indicare il Conto Corrente di accredito dell'avvaloramento del Conto Corrente Banca Profilo e allegare immagini nitide",
	"profile.documents.title": "Documenti",
	"profile.documents.app": "App",
	"profile.documents.bankaccount": "Conto Corrente",
	"profile.documents.prepaid": "Carta Prepagata",
	"profile.documents.signature": "Firma Digitale",
	"profile.documents.reporting": "Rendicontazione",
	"profile.documents.merchant": "Convenzionamento Merchant",
	"profile.documents.movement": "Movimenti",
	"profile.account.title": "Account",
	"profile.account.bankaccount": "Conto Corrente",
	"profile.account.prepaid": "Carta Prepagata",
	"profile.account.privacy": "Privacy",
	"profile.account.privacyInfo": "Informativa privacy",
	"taxation.title": "Fiscalità",
	"taxation.settings.invoices.title": "Attiva emissione fattura Tinaba",
	"taxation.settings.invoices.percentage": "Aliquota IVA applicata alle transazioni",
	"taxation.invoices.title": "Fatture e note di credito",
	"taxation.invoices.invoices": "Fatture",
	"taxation.invoices.notes": "Note",
	"taxation.closings.title": "Chiusure giornaliere",
	"taxation.closings.checkbox": "Scarica Zip Con fattura",
	"taxation.closings.details.title": "DETTAGLIO CHIUSURA",
	"taxation.closings.details.description": "Chiusura del ",
	"taxation.closings.details.description2": "ore ",
	"taxation.closings.details.total": "Totale:",
	"taxation.closings.details.4tax": "Aliquota 4%:",
	"taxation.closings.details.10tax": "Aliquota 10%:",
	"taxation.closings.details.22tax": "Aliquota 22%:",
	"taxation.closings.details.firstinvoice": "Dalla Fattura:",
	"taxation.closings.details.lastinvoice": "Alla Fattura:",
	"store.title": "Punti vendita",
	"store.register.selectStore": "Cambia punto vendita",
	"store.register.activation": "Per attivare una cassa, inserisci il codice attivazione sull'app pos tinaba.",
	"store.register.available": "Disponibile sugli store",
	"store.register.link": "o da pc con questo link https://pos.tinaba.it",
	"store.register.management": "I tuoi punti vendita",
	"store.register.search": "Cerca un punto vendita",
	"store.register.table.header.name": "Insegna",
	"store.register.table.header.id": "Identificativo univoco",
	"store.register.table.header.shopId": "Id punto vendita",
	"store.register.table.header.address": "Indirizzo",
	"store.search": "Cerca un punto vendita...",
	"store.add.title": "Crea nuovo punto vendita",
	"store.edit.title": "Modifica il punto vendita",
	"store.address": "Indirizzo",
	"store.description": "Descrizione",
	"store.data.title": "Dati visibili al tuo pubblico",
	"store.contacts.title": "Informazioni di contatto per tinaba",
	"store.insegna.title": "Nome insegna",
	"store.foto.title": "Foto",
	"store.created.success.modal": "Punto vendita creato con successo",
	"store.created.failed.modal": "Errore nella creazione del punto vendita",
	"store.edited.success.modal": "Punto vendita modificato con successo",
	"store.edited.failed.modal": "Errore nella modifica del punto vendita. Riprovare",
	"store.address.notvalid": "Indirizzo non valido",
	"store.address.notvalid.subtitle": "Controllare che tutti i campi dell'indirizzo siano stati inseriti correttamente",
	"store.insegna.notvalid": "Insegna del punto vendita non valida",
	"store.insegna.notvalid.subtitle": "Controllare che il campo insegna sia stato inserito correttamente",
	"store.duplicate": "Duplica",
	"store.edit": "Dettaglio store",
	"store.delete": "Elimina",
	"store.delete.title": "Elimina punto vendita",
	"store.delete.text": "Sei sicuro di eliminare il punto vendita? \n Tutte le casse collegate al punto vendita verranno eliminate.",
	"shop.title": "Casse",
	"shop.register.title": "Cassa",
	"shop.register.management": "Gestione Casse",
	"shop.register.default.title": "Cassa principale",
	"shop.register.default.hint": "Attiva cassa principale",
	"shop.register.default.overlay": "Vuoi attivare {{value}} come Cassa Principale? Puoi disattivarla in un secondo momento.",
	"shop.register.code.hint": "shop.code.hint",
	"shop.register.new.title": "Creazione nuova cassa",
	"shop.register.new.description": "Dai un nome alla cassa",
	"shop.register.new.placeholder": "Scrivi il nome...",
	"shop.register.new.button": "Genera Codice",
	"shop.register.table.header.main": "Cassa principale",
	"shop.register.table.header.state": "Stato",
	"shop.register.table.header.code": "Codice attivazione",
	"shop.register.table.header.delete": "Elimina",
	"shop.register.table.header.name": "Nome cassa",
	"shop.register.table.header.id": "Identificativo univoco",
	"shop.register.table.header.qrcode": "QR code di cassa",
	"shop.register.table.header.popup.main": "ATTIVA CASSA PRINCIPALE",
	"shop.register.table.header.popup.state": "ATTIVA/DISATTIVA CASSA",
	"shop.register.table.header.popup.code": "CODICE CASSA",
	"shop.register.table.button.main-device": "Cassa principale",
	"shop.register.table.button.qrcode": "Scarica espositore",
	"shop.register.device.smartphone": "SMARTPHONE",
	"shop.register.device.tablet": "TABLET",
	"shop.register.device.state.enabled": "Attiva",
	"shop.register.device.state.pending": "Non attivata",
	"shop.register.device.state.disabled": "Disabilitata",
	"shop.register.device.state.default": "Disabilitata",
	"shop.register.modal.cancel": "ANNULLA",
	"shop.register.modal.confirm": "CONFERMA",
	"shop.register.modal.errortitle": "ATTENZIONE",
	"shop.register.modal.newcash.title": "CREAZIONE NUOVA CASSA",
	"shop.register.modal.newcash.text": "Dai un nome alla cassa",
	"shop.register.modal.newcash.formaterror": "Formato non corretto",
	"shop.register.modal.newcash.lenghterror": "Nome troppo lungo",
	"shop.register.modal.newcash.samename": "Nome già in uso",
	"shop.register.modal.newcash.confirm": "GENERA CODICE",
	"shop.register.modal.deletecash.title": "ELIMINA CASSA",
	"shop.register.modal.deletecash.text1": "Vuoi davvero eliminare la cassa '{{name}}'? Rimuovendola non sarà più possibile recuperarla.",
	"shop.register.modal.deletecash.text2": "",
	"shop.register.modal.deletecash.confirm": "ELIMINA",
	"shop.register.modal.activemaincash.title": "ATTIVA CASSA",
	"shop.register.modal.activemaincash.text1": "Vuoi attivare",
	"shop.register.modal.activemaincash.text2": "come Cassa Principale? Puoi disattivarla in un secondo momento",
	"shop.register.modal.activemaincash.confirm": "ATTIVA",
	"shop.register.modal.disabledcash.text1": "Non è possibile impostare la cassa '",
	"shop.register.modal.disabledcash.text2": "' come cassa principale poiche è disabilitata",
	"shop.register.modal.newmaincash.title": "NUOVA CASSA PRINCIPALE",
	"shop.register.modal.newmaincash.text1": "Sei sicuro di voler impostare '",
	"shop.register.modal.newmaincash.text2": "' come cassa principale?",
	"shop.register.modal.newmaincash.confirm": "CONFERMA",
	"shop.register.modal.deletemaincash.title": "RIMUOVI CASSA PRINCIPALE",
	"shop.register.modal.deletemaincash.text1": "Sei sicuro di voler rimuovere '",
	"shop.register.modal.deletemaincash.text2": "' come cassa principale? Confermando, le proposte di pagamento non arriveranno più su questa applicazione",
	"shop.register.modal.disableerrormain.text": "Non è possibile disabilitare la cassa principale.",
	"shop.register.modal.pendingregistry.text": "Per attivare questa cassa devi inserire il codice accedendo all'app Tinaba Biz",
	"shop.register.modal.deleteerrormain.text1": "Non è possibile eliminare la cassa '",
	"shop.register.modal.deleteerrormain.text2": "' essendo la tua cassa principale, se vuoi eliminarla rimuovila da cassa principale.",
	"shop.register.modal.nottabletcash.text": "E' possibile attivare come Cassa Principale solo le Casse di tipo 'TABLET'",
	"shop.register.modal.onlyonetabletcash.text": "Non è possibile rimuovere questa cassa come principale perchè è l'unica cassa di tipo 'TABLET'",
	"shop.beacon.default.title": "Richiedere nuovo beacon",
	"shop.beacon.default.body": "Per richiedere un nuovo beacon o per ricevere assistenza contattaci al numero verde 800 151616 oppure invia una richiesta tramite il form sotto indicando il motivo del contatto",
	"shop.beacon.comments": "Commenti",
	"shop.beacon.reason": "Motivo",
	"services.title": "Servizi",
	"services.label.title": "Nome servizio",
	"services.label.activated": "ATTIVATO",
	"services.label.disactivated": "DISATTIVATO",
	"services.label.enable": "ABILITATO",
	"services.label.disable": "DISABILITATO",
	"services.label.active": "ATTIVA",
	"services.label.disactive": "DISATTIVA",
	"services.label.description": "Dai un nome al servizio: sarà quello che visualizzeranno i tuoi clienti dentro l'App Tinaba",
	"services.label.placeholder": "Dai un nome al servizio...",
	"services.activations.title": "Servizi Disponibili",
	"services.activations.modalTitle": "Attivazione del servizio",
	"services.activations.orders.title": "Acquista in negozio",
	"services.activations.orders.description": "Configura un listino prodotti e consenti ai tuoi clienti di acquistare direttamente da App.",
	"services.activations.checkin.title": "Servizi al tavolo",
	"services.activations.checkin.description": "Troppo caos nell’ora di punta? Tieni tutto sotto controllo: vedi i tuoi clienti quando entrano, quando chiedono il conto, ed escono senza passare dalla cassa. Velocizza il tuo lavoro con Tinaba",
	"services.activations.checkin.modalBody": "Attiva il servizio di pagamento con check-in per permettere ai tuoi clienti di pagare con check-in. Per attivare il servizio è necessario attivare il servizio. Una volta che il servizio sarà stato attivato, il servizio sarà attivo ed i clienti potranno pagare con check-in.",
	"services.activations.taxation.description": "Attiva il servizio per gestire gli aspetti fiscali delle transazioni con Tinaba",
	"services.activations.paypal.title": "Paypal",
	"services.activations.paypal.description": "Consenti a tutti i tuoi clienti di completare un pagamento anche con PayPal e carte di credito. Crea un account Paypal o usane uno già attivo e collegalo al tuo account Tinaba.",
	"services.activations.paypal.status.enabled": "Il servizio è visibile agli utenti Paypal. Per nascorderlo, clicca sul pulsante",
	"services.activations.paypal.status.disabled": "Il servizio è attivo ma non visibile agli utenti Paypal. Per renderlo visibile a tutti gli utenti Paypal, clicca sul pulsante ",
	"services.activations.promoOutbound.title": "Know your client",
	"services.activations.promoOutbound.description": "Parla con i tuoi clienti e intraprendi strategie di marketing mirate e attività di loyalty, anticipando l’esperienza d’acquisto. Invia notifiche push ai clienti Tinaba abituali che ti hanno selezionato come preferito e comunica con tutti i clienti Tinaba che rilevano il segnale Bluetooth del Beacon associato al tuo negozio.",
	"services.activations.order.info": "In questa pagina puoi configurare il servizio. Per salvare le modifiche apportate, è necessario completare l’operazione con il tasto «SALVA» in fondo alla pagina",
	"services.activations.order.status.enabled": "Il servizio è visibile agli utenti Tinaba. Per nascorderlo, clicca sul pulsante e salva le modifiche",
	"services.activations.order.status.disabled": "Il servizio è attivo ma non visibile agli utenti Tinaba. Per renderlo visibile a tutti gli utenti Tinaba, clicca sul pulsante e salva la modifiche.",
	"services.activations.orderAndPay.title": "Acquisto in negozio",
	"services.activations.orderAndPay.description": "Comunicare direttamente con i tuoi clienti abituali? Manda messaggi e promozioni dedicate direttamente con l’app: Scopri la comunicazione 2.0 con Tinaba.",
	"services.activations.orderAndPick.title": "Take away",
	"services.activations.orderAndPick.description": "Configura un listino prodotti e gli orari di disponibilità e consenti ai tuoi clienti di ordinare e pagare direttamente da App. Prepara l’ordine e aspetta che passino a ritirarlo!",
	"services.activations.orderAndDelivery.title": "Consegna a domicilio",
	"services.activations.orderAndDelivery.description": "Configura un listino prodotti, gli orari e l’area di consegna e consenti ai tuoi clienti di ordinare e pagare direttamente da App. Prepara l’ordine e consegnalo all’indirizzo concordato!",
	"services.activations.officeDelivery.title": "Consegna in ufficio",
	"services.activations.officeDelivery.description": "Configura un listino prodotti, gli orari e l’area di consegna e consenti ai tuoi clienti di ordinare e pagare direttamente da App. Prepara l’ordine e consegnalo all’indirizzo dell’ufficio!",
	"services.activations.orderAtTable.title": "Ordina al tavolo",
	"services.activations.orderAtTable.description": "Configura il tuo menù e consenti ai tuoi clienti di ordinare e pagare direttamente da App indicando il numero del tavolo.",
	"services.activations.billAtTable.title": "Conto al tavolo",
	"services.activations.billAtTable.description": "Lascia pagare i tuoi clienti direttamente al tavolo, senza venire in cassa.",
	"services.activations.invoices.title": "Fatturazione",
	"services.activations.invoices.description": "Attiva la generazione di una fattura digitale per i pagamenti collegati ai servizi VAS (ACQUISTA IN NEGOZIO, TAKE AWAY, CONSEGNA A DOMICILIO, CONSEGNA IN UFFICIO, ORDINA AL TAVOLO, CONTO AL TAVOLO)",
	"services.activations.payWithAlipay.title": "Pagamenti con Alipay",
	"services.activations.payWithAlipay.info": "In questa pagina puoi configurare il servizio. Per salvare le modifiche apportate, è necessario completare l’operazione con il tasto «SALVA» in fondo alla pagina",
	"services.activations.payWithAlipay.description": "Attiva la ricezione dei pagamenti in negozio tramite Alipay",
	"services.activations.payWithAlipay.status.enabled": "Il servizio è visibile agli utenti Alipay. Per nascorderlo, clicca sul pulsante e salva le modifiche",
	"services.activations.payWithAlipay.status.disabled": "Il servizio è attivo ma non visibile agli utenti Alipay. Per renderlo visibile a tutti gli utenti Alipay, clicca sul pulsante e salva la modifiche.",
	"services.activations.projectWithAlipay.title": "Sponsorizzazione Alipay progetti pubblici di enti",
	"services.activations.projectWithAlipay.info": "In questa pagina puoi configurare il servizio. Per salvare le modifiche apportate, è necessario completare l’operazione con il tasto «SALVA» in fondo alla pagina",
	"services.activations.projectWithAlipay.description": "Attiva la ricezione di donazioni tramite Alipay",
	"services.activations.projectWithAlipay.status.enabled": "Il servizio è visibile agli utenti Alipay. Per nascorderlo, clicca sul pulsante e salva le modifiche",
	"services.activations.projectWithAlipay.status.disabled": "Il servizio è attivo ma non visibile agli utenti Alipay. Per renderlo visibile a tutti gli utenti Alipay, clicca sul pulsante e salva la modifiche.",
	"services.activations.mobilePayWithAlipay.title": "Street artist Alipay",
	"services.activations.mobilePayWithAlipay.info": "In questa pagina puoi configurare il servizio. Per salvare le modifiche apportate, è necessario completare l’operazione con il tasto «SALVA» in fondo alla pagina",
	"services.activations.mobilePayWithAlipay.description": "Attiva la ricezione di pagamenti P2P tramite Alipay",
	"services.activations.mobilePayWithAlipay.status.enabled": "Il servizio è visibile agli utenti Alipay. Per nascorderlo, clicca sul pulsante e salva le modifiche",
	"services.activations.mobilePayWithAlipay.status.disabled": "Il servizio è attivo ma non visibile agli utenti Alipay. Per renderlo visibile a tutti gli utenti Alipay, clicca sul pulsante e salva la modifiche.",
	"services.activations.cash.title": "Cassa azienda",
	"services.activations.cash.info": "In questa pagina puoi configurare il servizio. Per salvare le modifiche apportate, è necessario completare l’operazione con il tasto «SALVA» in fondo alla pagina",
	"services.activations.cash.description": "Attivazione / disattivazione della cassa azienda",
	"services.activations.alipayOnline.title": "Alipay Online",
	"services.activations.alipayOnline.info": "E' il servizio che ti consente di ricevere pagamenti a distanza da utenti Alipay tramite la funzione Link to Pay presente in Tinaba POS e sul tuo canale e-commerce se hai configurato Tinaba tra le modalità di pagamento",
	"services.activations.alipayOnline.description": "Ricevi pagamenti a distanza da utenti Alipay",
	"services.activations.alipayOnline.status.enabled": "Il servizio è visibile agli utenti Alipay. Per nascorderlo, clicca sul pulsante e salva le modifiche",
	"services.activations.alipayOnline.status.disabled": "Il servizio è attivo ma non visibile agli utenti Alipay. Per renderlo visibile a tutti gli utenti Alipay, clicca sul pulsante e salva la modifiche.",
	"services.activations.buttons.activate.modal.title": "Attivazione Vas",
	"services.activations.buttons.activate.modal.title.enable": "Richiedi l'attivazione del servizio",
	"services.activations.buttons.activate.modal.title.disable": "Disattivazione del servizio",
	"services.activations.buttons.activate.modal.description": "Per ricevere informazioni e richiedere l’attivazione del servizio contattaci all’indirizzo email business@tinaba.it indicando:",
	"services.deactivations.buttons.activate.modal.description": "Per richiedere La disattivazione del servizio contattaci all’indirizzo email business@tinaba.it indicando:",
	"services.buttons.activate.modal.option1": "Recapito telefonico al quale vuoi essere contattato",
	"services.buttons.activate.modal.option2": "Orario di disponibilità (da Lunedì a Venerdì, dalle 9.00 alle 18.00)",
	"services.buttons.activate.modal.option3": "Tipologia di servizi ai quali sei interessato",
	"services.activations.buttons.activate.modal.button": "Chiudi",
	"services.activations.buttons.activate": "Attiva",
	"services.activations.buttons.deactivate": "Disattiva",
	"services.activations.buttons.configure": "Configura",
	"services.activations.buttons.active": "Abilita",
	"services.activations.buttons.disable": "Disattiva",
	"services.activations.header": "La tua visibilita' risulta spenta. Attivala per renderti visibile sulla lista esercenti dell'app tinaba",
	"services.activations.header.enabled": "La tua visibilità profilo è impostata correttamente",
	"checkin.title": "Check-in",
	"checkin.enable": "Abilita check-in",
	"checkin.fastcheckout.title": "Abilita fast check-out",
	"checkin.fastcheckout.amount": "Importo richiesto per preautorizzazione",
	"checkin.tables": "Abilita gestione tavoli",
	"menu.title": "Listini",
	"menu.main.body": "Il servizio è visualizzato dai tuoi clienti con il nome ORDINA",
	"menu.main.empty": "Nessun listino trovato",
	"menu.main.associate": "Associa prodotti",
	"menu.main.description": "Qui puoi gestire i prodotti che compongono il tuo menù.",
	"menu.main.count.empty": "Nessun prodotto",
	"menu.main.count.product": "{{count}} prodotto",
	"menu.main.count.products": "{{count}} prodotti",
	"menu.main.delete.title": "Elimina listino",
	"menu.main.delete.body": "Vuoi davvero eliminare {{name}}?",
	"menu.main.manage.title": "Gestione listino",
	"menu.main.manage.body": "Sei sicuro di voler impostare “{{name}}” come nuovo listino?",
	"menu.main.new.title": "Crea Listino",
	"menu.main.modal.errortitle": "Attenzione",
	"menu.main.modal.modalbody.deactivemenu": "Questo listino è attualmente visibile ai tuoi clienti, se vuoi disattivarlo attiva un altro listino oppure disabilita temporaneamente la gestione listini dalla sezione “configurazione”",
	"menu.main.modal.modalbody.deletemenu": "{{name}} è attivo e non può essere rimosso. Per eliminare {{name}} attiva un altro listino oppure disabilita temporaneamente la gestione listini dalla sezione “configurazione”",
	"menu.main.take": "Attiva modalità TAKE AWAY",
	"menu.main.order": "Attiva modalità ORDINA AL TAVOLO",
	"menu.catalog.title": "Catalogo",
	"menu.catalog.search": "Cerca nel catalogo...",
	"menu.catalog.products.title": "Prodotti",
	"menu.catalog.products.category": "Categoria",
	"menu.catalog.products.subcategory": "Sottocategoria",
	"menu.catalog.products.product": "Prodotto",
	"menu.catalog.products.image": "Img",
	"menu.catalog.products.associate": "Associa ai listini",
	"menu.catalog.products.empty": "Nessun prodotto trovato",
	"menu.catalog.products.all": "Tutti",
	"menu.catalog.products.none": "Nessuno",
	"menu.catalog.products.error.name": "Il nome del prodotto è richiesto",
	"menu.catalog.products.error.description": "La descrizione del prodotto è necessaria",
	"menu.catalog.products.error.price": "Il prezzo del prodotto è necessario",
	"menu.catalog.products.error.category": "La categoria del prodotto è necessaria",
	"menu.catalog.products.error.subcategory": "La sottocategoria è necessaria",
	"menu.catalog.products.new.title": "Aggiungi prodotto",
	"menu.catalog.products.remove.title": "Rimuovi prodotto",
	"menu.catalog.products.remove.body.description": "Vuoi davvero rimuovere {{name}} dal listino?",
	"menu.catalog.products.remove.body.notice": "Rimuovendolo non sarà più visibile in questo listino.",
	"menu.catalog.products.delete.title": "Elimina prodotto",
	"menu.catalog.products.delete.body.description": "Vuoi davvero eliminare {{name}} {{description}} dal catalogo?",
	"menu.catalog.products.delete.body.notice": "Rimuovendolo verrà eliminato anche da tutti i listini.",
	"menu.settings.enable": "Abilita gestione listini",
	"menu.settings.modal": "Per abilitare il servizio devi aver attivato almeno un listino. Accedi alla sezione “listini” per gestirli",
	"menu.discount.title": "Sconti",
	"menu.discount.error.name": "Il nome dello sconto è richiesto!",
	"menu.discount.error.description": "Il descrizione dello sconto è richiesta",
	"menu.categories.deleteCategory": "Elimina categoria",
	"menu.categories.addSubcategory": "Aggiungi sotto categoria",
	"menu.categories.description": "Qui puoi gestire le sotto categorie della macro categoria selezionata",
	"menu.categories.new.title": "Aggiungi categoria",
	"menu.categories.edit.title": "Modifica categoria",
	"menu.category.delete.body.description": "Vuoi davvero eliminare {{name}} dalle sotto categorie?",
	"menu.categories.products.delete.title": "Elimina categoria",
	"outbound.message.title": "Nuova promo",
	"outbound.message.form.title": "Scegli, tra i clienti Tinaba che ti hanno scelto come «preferito»  quelli che riceveranno il tuo messaggio.\n Ricorda, puoi inviare un messaggio ogni 7 giorni.",
	"outbound.message.form.ex-title": "Scegli, tra i clienti Tinaba che ti hanno scelto come «preferito»  quelli che riceveranno il tuo messaggio.\n Ricorda, puoi inviare un messaggio ogni 7 giorni.",
	"outbound.message.main.title": "",
	"outbound.message.main.subtitle": "Scegli la campagna più adatta tra quelle possibili,\npersonalizza con i tuoi messaggi e invia!",
	"outbound.message.progessbar_steps.targets": "Seleziona destinatari",
	"outbound.message.progessbar_steps.customization": "Configura promo",
	"outbound.message.progessbar_steps.timing": "Seleziona periodo",
	"outbound.message.progessbar_steps.preview": "Riepilogo e conferma",
	"outbound.message.slider.label": "Cosa vedranno i tuoi clienti",
	"outbound.message.slider.slide_0.title": "Appari in home",
	"outbound.message.slider.slide_0.text": "Dentro la prima pagina di Tinaba, l'icona merchant inizierà a lampeggiare",
	"outbound.message.slider.slide_1.title": "Fatti riconoscere",
	"outbound.message.slider.slide_1.text": "Nella lista il tuo punto vendita sarà evidenziato dalla promo che hai attivato",
	"outbound.message.slider.slide_2.title": "Comunica dalla tua vetrina",
	"outbound.message.slider.slide_2.text": "Nella pagina del negozio verrà mostrato il messaggio creato da te",
	"outbound.message.slider.slide_3.title": "Notifiche push",
	"outbound.message.slider.slide_3.text": "Una notifica push avvertirà il cliente della nuova promo attiva",
	"outbound.message.step_1.raggiungi_clienti": "raggiungi i tuoi clienti ovunque",
	"outbound.message.step_1.saluta_clienti": "saluta i tuoi clienti",
	"outbound.message.bound_type.title_main": "",
	"outbound.message.bound_type.subtitle_main": "",
	"outbound.message.bound_type.inbound.title": "Dentro il negozio e nelle vicinanze",
	"outbound.message.bound_type.inbound.recap.title": "Dentro il negozio e nelle vicinanze",
	"outbound.message.bound_type.inbound.subtitle": "Manda un messaggio ai clienti che entrano nel tuo negozio e pubblicizza le tue promozioni nella lista geolocalizzata degli esercenti Tinaba",
	"outbound.message.bound_type.outbound.title": "Verso i tuoi clienti preferiti",
	"outbound.message.bound_type.outbound.recap.title": "Verso i tuoi clienti preferiti",
	"outbound.message.bound_type.outbound.subtitle": "Manda una notifica ai clienti che ti hanno inserito tra i preferiti",
	"outbound.message.bound_type.welcome.title": "Messaggio benvenuto",
	"outbound.message.bound_type.welcome.subtitle": "Imposta un messaggio di default per i clienti che entrano nel tuo negozio",
	"outbound.message.bound_type.welcome.welcome.title": "Messaggio di Benvenuto",
	"outbound.message.bound_type.welcome.welcome.subtitle": "Per chi entra per la prima volta",
	"outbound.message.bound_type.welcome.welcome_back.title": "Messaggio di Bentornato",
	"outbound.message.bound_type.welcome.welcome_back.subtitle": "Per chi ha già acquistato da te",
	"outbound.message.bound_type.inbound.rich_type.title_main": "Non perderti neanche un cliente",
	"outbound.message.bound_type.inbound.rich_type.subtitle_main": "Invia loro notifiche push anche quando c'è ressa in negozio",
	"outbound.message.bound_type.inbound.rich_type.welcome.title": "Manda un saluto",
	"outbound.message.bound_type.inbound.rich_type.welcome.subtitle": "Accogli i nuovi clienti e quelli abituali",
	"outbound.message.bound_type.inbound.rich_type.fedelity.title": "Premia i clienti",
	"outbound.message.bound_type.inbound.rich_type.fedelity.subtitle": "Invia promozioni personalizzate a chi ha già acquistato da te con Tinaba",
	"outbound.message.bound_type.inbound.rich_type.promo.title": "Fatti conoscere",
	"outbound.message.bound_type.inbound.rich_type.promo.subtitle": "Convinci i nuovi clienti ad acquistare con Tinaba",
	"outbound.message.bound_type.welcome.title_main": "Dai il benvenuto a chi entra nel tuo negozio",
	"outbound.message.bound_type.welcome.subtitle_main": "Manda una notifica ai clienti che entrano nel tuo negozio con il bluetooth acceso",
	"outbound.message.bound_type.inbound.rich_type.welcome.welcome.title": "Messaggio di Benvenuto",
	"outbound.message.bound_type.inbound.rich_type.welcome.welcome.subtitle": "Per chi entra per la prima volta",
	"outbound.message.bound_type.inbound.rich_type.welcome.welcome_back.title": "Messaggio di Bentornato",
	"outbound.message.bound_type.inbound.rich_type.welcome.welcome_back.subtitle": "Per chi ha già acquistato da te",
	"outbound.message.bound_type.inbound.rich_type.fedelity.targets.title_main": "A chi vuoi inviare la tua campagna?",
	"outbound.message.bound_type.inbound.rich_type.fedelity.targets.subtitle_main": "Scegli i clienti che vuoi contattare tra queste categorie",
	"outbound.message.bound_type.inbound.rich_type.fedelity.targets.abituali.title": "Abituali",
	"outbound.message.bound_type.inbound.rich_type.fedelity.targets.abituali.subtitle": "Li vedi quasi ogni giorno",
	"outbound.message.bound_type.inbound.rich_type.fedelity.targets.rischio_abbandono.title": "Rischio Abbandono",
	"outbound.message.bound_type.inbound.rich_type.fedelity.targets.rischio_abbandono.subtitle": "Non vengono più come un tempo",
	"outbound.message.bound_type.inbound.rich_type.fedelity.targets.occasionali.title": "Occasionali",
	"outbound.message.bound_type.inbound.rich_type.fedelity.targets.occasionali.subtitle": "Non ti ricordi nemmeno il loro nome",
	"outbound.message.bound_type.inbound.rich_type.fedelity.targets.vip.title": "VIP",
	"outbound.message.bound_type.inbound.rich_type.fedelity.targets.vip.subtitle": "Quelli che acquistano di più",
	"outbound.message.bound_type.inbound.rich_type.fedelity.targets.under_25.title": "Under 25",
	"outbound.message.bound_type.inbound.rich_type.fedelity.targets.under_25.subtitle": "I clienti più giovani",
	"outbound.message.bound_type.inbound.rich_type.fedelity.targets.all.title": "Tutti i clienti",
	"outbound.message.bound_type.inbound.rich_type.fedelity.targets.all.subtitle": "Senza distinzioni",
	"outbound.message.bound_type.inbound.rich_type.fedelity.targets.personalizzabile.title": "Altri",
	"outbound.message.bound_type.inbound.rich_type.fedelity.targets.personalizzabile.subtitle": "Personalizza il tuo pubblico",
	"outbound.message.bound_type.inbound.rich_type.promo.targets.title_main": "A chi vuoi inviare la tua campagna?",
	"outbound.message.bound_type.inbound.rich_type.promo.targets.subtitle_main": "Scegli i clienti che vuoi contattare tra queste categorie",
	"outbound.message.bound_type.inbound.rich_type.promo.targets.interessi.title": "Ad Alto Potenziale",
	"outbound.message.bound_type.inbound.rich_type.promo.targets.interessi.subtitle": "Spendono molto in negozi simili al tuo",
	"outbound.message.bound_type.inbound.rich_type.promo.targets.nei_dintorni.title": "Nei dintorni",
	"outbound.message.bound_type.inbound.rich_type.promo.targets.nei_dintorni.subtitle": "Acquistano vicino a te",
	"outbound.message.bound_type.inbound.rich_type.promo.targets.under_25.title": "Under 25",
	"outbound.message.bound_type.inbound.rich_type.promo.targets.under_25.subtitle": "I clienti più giovani",
	"outbound.message.bound_type.inbound.rich_type.promo.targets.grandi_spese.title": "Grandi spese",
	"outbound.message.bound_type.inbound.rich_type.promo.targets.grandi_spese.subtitle": "Fanno grandi acquisti con la App",
	"outbound.message.bound_type.inbound.rich_type.promo.targets.all.title": "Tutti i clienti",
	"outbound.message.bound_type.inbound.rich_type.promo.targets.all.subtitle": "Senza distinzioni",
	"outbound.message.bound_type.inbound.rich_type.promo.targets.personalizzabile.title": "Altri",
	"outbound.message.bound_type.inbound.rich_type.promo.targets.personalizzabile.subtitle": "Personalizza il tuo pubblico",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.title_main": "Seleziona i clienti ai quali vuoi rivolgerti",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.subtitle_main": "",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.abituali.title": "Abituali",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.abituali.subtitle": "Li vedi quasi ogni giorno",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.rischio_abbandono.title": "Rischio Abbandono",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.rischio_abbandono.subtitle": "Non vengono più come un tempo",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.occasionali.title": "Occasionali",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.occasionali.subtitle": "Non ti ricordi nemmeno il loro nome",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.vip.title": "VIP",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.vip.subtitle": "Quelli che acquistano di più",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.under_25.title": "Under 25",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.under_25.subtitle": "I clienti più giovani",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.all.title": "Tutti i clienti",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.all.subtitle": "Senza distinzioni",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.personalizzabile.title": "Altri",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.personalizzabile.subtitle": "Personalizza il tuo pubblico",
	"outbound.message.step_2.personalizza.title": "Vuoi modificare questa categoria? Clicca qui per personalizzare i filtri impostati",
	"outbound.message.step_2.anagrafica.title": "Anagrafica",
	"outbound.message.step_2.anagrafica.sex.label": "Sesso",
	"outbound.message.step_2.anagrafica.sex.all": "Entrambi i sessi",
	"outbound.message.step_2.anagrafica.sex.female": "Donna",
	"outbound.message.step_2.anagrafica.sex.male": "Uomo",
	"outbound.message.step_2.anagrafica.age.label": "Età",
	"outbound.message.step_2.anagrafica.age.all": "Tutte le età",
	"outbound.message.step_2.anagrafica.age.12-17": "12 - 17",
	"outbound.message.step_2.anagrafica.age.18-29": "18 - 29",
	"outbound.message.step_2.anagrafica.age.30-39": "30 - 39",
	"outbound.message.step_2.anagrafica.age.40-49": "40 - 49",
	"outbound.message.step_2.anagrafica.age.50+": "Over 50",
	"outbound.message.step_2.anagrafica.city.label": "Dove vive",
	"outbound.message.step_2.anagrafica.city.near_me": "Vicino a Me (fino a 1km)",
	"outbound.message.step_2.anagrafica.city.in_my_city": "Nella tua Città",
	"outbound.message.step_2.anagrafica.city.all": "Qualsiasi",
	"outbound.message.step_2.anagrafica.city.milano": "Milano",
	"outbound.message.step_2.anagrafica.city.roma": "Roma",
	"outbound.message.step_2.comportamento.title": "Comportamento",
	"outbound.message.step_2.comportamento.last_pay.label": "Ultimo pagamento",
	"outbound.message.step_2.comportamento.last_pay.last_week": "Ultima settimana",
	"outbound.message.step_2.comportamento.last_pay.last_month": "Ultimo mese",
	"outbound.message.step_2.comportamento.last_pay.last_3_months": "Ultimi 3 mesi",
	"outbound.message.step_2.comportamento.last_pay.last_6_months": "Ultimi 6 mesi",
	"outbound.message.step_2.comportamento.last_pay.last_year": "Ultimo anno",
	"outbound.message.step_2.comportamento.frequency.label": "Frequenza",
	"outbound.message.step_2.comportamento.frequency.high": "Alta",
	"outbound.message.step_2.comportamento.frequency.medium": "Media",
	"outbound.message.step_2.comportamento.frequency.low": "Bassa",
	"outbound.message.step_2.comportamento.frequency.all": "Qualsiasi",
	"outbound.message.step_2.comportamento.frequency.in_aumento": "In Aumento",
	"outbound.message.step_2.comportamento.frequency.in_diminuzione": "In Diminuzione",
	"outbound.message.step_2.comportamento.similar.label": "Acquisti simili",
	"outbound.message.step_2.comportamento.similar.yes": "Si",
	"outbound.message.step_2.comportamento.similar.no": "No",
	"outbound.message.step_2.comportamento.similar.all": "Qualsiasi",
	"outbound.message.step_2.comportamento.where_buy.label": "Dove Compra",
	"outbound.message.step_2.comportamento.where_buy.near_me": "Vicino a Me (fino a 1km)",
	"outbound.message.step_2.comportamento.where_buy.in_my_city": "Nella tua Città",
	"outbound.message.step_2.comportamento.where_buy.all": "Qualsiasi",
	"outbound.message.step_2.comportamento.where_buy.medium": "Media",
	"outbound.message.step_2.comportamento.where_buy.low": "Bassa",
	"outbound.message.step_2.comportamento.already_buy.label": "Ha già acquistato con tinaba presso di te?",
	"outbound.message.step_2.comportamento.already_buy.yes": "Ha già acquistato presso di te",
	"outbound.message.step_2.comportamento.already_buy.no": "Non ha già acquistato presso di te",
	"outbound.message.step_2.comportamento.already_buy.all": "Tutti i clienti",
	"outbound.message.bound_type.inbound.rich_type.not_set.targets.title_main": "Seleziona i clienti ai quali vuoi rivolgerti",
	"outbound.message.bound_type.inbound.rich_type.not_set.targets.subtitle_main": "",
	"outbound.message.bound_type.inbound.rich_type.not_set.targets.personalizzabile.customization.sale.title": "Comunica uno sconto",
	"outbound.message.bound_type.inbound.rich_type.not_set.targets.personalizzabile.customization.gift.title": "Comunica un omaggio",
	"outbound.message.bound_type.inbound.rich_type.not_set.targets.personalizzabile.customization.event.title": "Comunica un evento",
	"outbound.message.bound_type.inbound.rich_type.not_set.targets.personalizzabile.customization.sale.recap": "Sconto",
	"outbound.message.bound_type.inbound.rich_type.not_set.targets.personalizzabile.customization.gift.recap": "Omaggio",
	"outbound.message.bound_type.inbound.rich_type.not_set.targets.personalizzabile.customization.event.recap": "Evento",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.personalizzabile.customization.sale.title": "Comunica uno sconto",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.personalizzabile.customization.gift.title": "Comunica un omaggio",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.personalizzabile.customization.event.title": "Comunica un evento",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.personalizzabile.customization.sale.recap": "Sconto",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.personalizzabile.customization.gift.recap": "Omaggio",
	"outbound.message.bound_type.outbound.rich_type.not_set.targets.personalizzabile.customization.event.recap": "Evento",
	"outbound.message.steps.customization.title_main": "Il Tuo messaggio",
	"outbound.message.steps.customization.subtitle_main": "",
	"outbound.message.steps.customization.sale.title": "Comunica uno sconto",
	"outbound.message.steps.customization.gift.title": "Comunica un omaggio",
	"outbound.message.steps.customization.event.title": "Comunica un evento",
	"outbound.message.steps.customization.sale.recap": "Sconto",
	"outbound.message.steps.customization.gift.recap": "Omaggio",
	"outbound.message.steps.customization.event.recap": "Evento",
	"outbound.message.steps.customization.messages_table.model": "Modello",
	"outbound.message.steps.customization.messages_table.message": "Messaggio",
	"outbound.message.steps.customization.messages_table.edit": "Modifica",
	"outbound.message.steps.customization.distance": "Seleziona il raggio di visualizzazione",
	"outbound.message.steps.customization.customization_distance.2": "Fino a 2 km",
	"outbound.message.steps.customization.customization_distance.5": "Fino a 5 km",
	"outbound.message.steps.customization.customization_distance.10": "Fino a 10 km",
	"outbound.message.steps.timing.title_main": "",
	"outbound.message.steps.timing.subtitle_main": "",
	"outbound.message.steps.timing.timing.title": "Tempistiche di invio",
	"outbound.message.steps.timing.timing.morning": "Mattina (Dalle 8:00 alle 14:00)",
	"outbound.message.steps.timing.timing.afternoon": "Pomeriggio (Dalle 14:00 alle 18:00)",
	"outbound.message.steps.timing.timing.evening": "Sera (Dalle 18:00 alle 24:00)",
	"outbound.message.steps.timing.timing.all_day": "Tutto il giorno (Dalle 8:00 alle 24:00)",
	"outbound.message.steps.preview.title_main": "Riepilogo e conferma",
	"outbound.message.steps.preview.subtitle_main": "",
	"outbound.message.customization.textarea": "Scrivi qui:",
	"outbound.message.preview.message": "Anteprima messaggio",
	"outbound.message.form.table.cluster": "Seleziona un cluster:",
	"outbound.message.form.table.number": "Numero clienti",
	"outbound.message.form.message": "Messaggio",
	"outbound.message.form.send": "Invia",
	"outbound.message.form.placeholder": "Esempio: Sconto del 10%",
	"outbound.message.form.placeholder.welcome": "Esempio: Benvenuto nel mio negozio!",
	"outbound.message.form.placeholder.welcome_back": "Esempio: Bentornato nel mio negozio!",
	"outbound.message.modal.show.title": "Dettaglio Promozione",
	"outbound.message.modal.title": "Invia messaggio",
	"outbound.message.modal.body": "Sei sicuro di voler inviare il seguente messaggio?<br /> Sarà inviato solo al gruppo che hai selezionato",
	"outbound.message.modal_delete.show.title": "Elimina Promozione",
	"outbound.message.modal_delete.body": "Sei sicuro di voler eliminare la seguente promozione?<br /> Alcuni clienti potrebbero averla già letta",
	"outbound.active_promo.title": "Promo Attive",
	"outbound.history.title": "Storico",
	"outbound.message.history.title_main": "Storico Promozioni",
	"outbound.message.history.subtitle_main": "Visualizza il dettaglio delle promozioni scadute",
	"outbound.message.active_promo.title_main": "Lista Promozioni Attive",
	"outbound.message.active_promo.subtitle_main": "Visualizza il dettaglio delle promozioni che hai già attivato oppure che stanno per scadere",
	"outbound.message.active_promo.inbound.title_main": "Dentro il negozio e nelle vicinanze",
	"outbound.message.active_promo.outbound.title_main": "Verso i tuoi clienti preferiti",
	"outbound.message.active_promo.table.bound_type": "Dove",
	"outbound.message.active_promo.table.content_type": "Tipo promo",
	"outbound.message.active_promo.table.targets": "Target selezionato",
	"outbound.message.active_promo.table.message": "Messaggio inserito",
	"outbound.message.active_promo.table.period": "Periodo di validità",
	"outbound.message.active_promo.table.status": "Stato",
	"outbound.message.active_promo.table.show": "Visualizza",
	"outbound.message.active_promo.table.delete": "Elimina",
	"outbound.message.active_promo.content_type.sale.title": "Sconto",
	"outbound.message.active_promo.content_type.gift.title": "Omaggio",
	"outbound.message.active_promo.content_type.event.title": "Evento",
	"outbound.message.active_promo.content_type.not_set.title": "-",
	"outbound.history.table.date": "Data Creazione",
	"outbound.history.table.message": "Messaggio",
	"outbound.history.table.groups": "Gruppi",
	"outbound.history.nomessage": "Nessun messaggio trovato",
	"outbound.state.active": "Attiva",
	"outbound.state.inactive": "Inattiva",
	"outbound.state.expired": "Scaduta",
	"outbound.state.archived": "Scaduta",
	"vas.pickupPoint.new.title": "Aggiungi punto di ritiro",
	"vas.pickupPoint.edit.title": "Modifica punto di ritiro",
	"vas.pickupPoint.title": "Punti di ritiro"
};
var module;
try {
	module = angular.module("translations");
} catch(err) {
	module = angular.module("translations", ["pascalprecht.translate"]);
}
module.config(["$translateProvider", function($translateProvider) {
	$translateProvider.translations("it_IT", translations);
}]);
module.exports = translations;


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/translations/it_IT.json
 ** module id = 679
 ** module chunks = 0
 **/